import script from "./JoinFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./JoinFrame.vue?vue&type=script&setup=true&lang=js"

import "./JoinFrame.vue?vue&type=style&index=0&id=343c780e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-343c780e"]])

export default __exports__